<template>
  <section id="agent-list" class="content">

    <section class="content-toolbar">
      <button
        class="btn btn-primary"
        v-on:click="displayAgentCreationBox">
        Ajouter un agent
      </button>
    </section>

    <message
      :obj=agents.message
      hide-mutation-type="CLEAR_AGENTS_MESSAGE">
    </message>

    <change-password-modal
      v-if="agents.passwordChangeModal.visible"
      hide-dispatch-action="closePasswordChangeModal"
      change-dispatch-action="changeAgentPassword"
      :can-only-exit-modal="agents.passwordChangeModal.canOnlyExitModal"
      :is-loading="agents.passwordChangeModal.loading"
      :message="agents.passwordChangeModal.message"
      :selected-person="selectedAgent">
    </change-password-modal>

    <deactivation-modal
      v-if="showConfirmModal"
      title="Désactivation d'un agent"
      :data="selectedAgent"
      @close="showConfirmModal = false"
      @confirm="deactivateAgent">
    </deactivation-modal>

    <person-create-view
      v-if="agents.isActiveCreatedAgentModal"
      @close="resetCreateModal"
      @confirm="createAgent">
    </person-create-view>

    <content-row
      v-for="a in sortedAgents"
      :is-open="selectedAgent.id === a.id"
      :mark-as-deactivated="!a.actif"
      @open="openAgentDetails(a)"
      @close="closeAgentDetails()">

      <div slot="main-close">
        <div class="col-sm-5 right-separator">
          <div class="title-item">PRÉNOM, NOM</div>
          <div class="text-item">{{ a.prenom }} {{ a.nom }}</div>
        </div>
        <div class="col-sm-4 right-separator">
          <div class="title-item">DERNIÈRE TOURNÉE</div>
          <ul v-if="a.nomDerniereTournee !== null && a.nomDerniereTournee !== undefined">
            <li class="text-item">{{ a.nomDerniereTournee }}</li>
            <li class="text-item">{{ a.dateDerniereTournee | dateFormatter }}</li>
            <li class="text-item" v-if="a.profile === 'Novice'">
              {{ a.progressLastTournee ? a.progressLastTournee : 0 }}%
            </li>
          </ul>
          <div class="text-item" v-if="!a.nomDerniereTournee">
            <span class="no-data">-</span>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="title-item">DERNIÈRE ACTIVITÉ</div>
          <div v-if="a.lastActivity"
               class="text-item last-activity"
               :class="getLastActivityClass(a.lastActivity)"
          >
            <div class="pastille"></div>
            <span>{{ !a.lastActivity ? '' : a.lastActivity | dateFormatterLastActivity }}</span>
          </div>
          <div v-if="!a.lastActivity"
               class="text-item last-activity">
            <span class="no-data">-</span>
          </div>
        </div>
      </div>

      <div slot="main-open">
        <div class="col-sm-4 item-details">
          <div class="col-sm-6 col--noLeftPadding">
            <div class="title-item">PRÉNOM</div>
            <div class="text-item" v-if="editingAgentId !== a.id">{{ a.prenom }}</div>
            <input class="col-sm-12 form-control input-edit" type="text" v-if="editingAgentId === a.id"
                   v-model="edit.prenom"/>
            <div class="error-message">
              {{ prenomValidationMessage }}
            </div>
          </div>
          <div class="col-sm-6 col--noRightPadding">
            <div class="title-item">NOM</div>
            <div class="text-item" v-if="editingAgentId !== a.id">{{ a.nom }}</div>
            <input v-if="editingAgentId === a.id" class="col-sm-12 form-control input-edit" type="text"
                   v-model="edit.nom"/>
            <div class="error-message">
              {{ nomValidationMessage }}
            </div>
          </div>
          <div class="col-sm-6 col--noLeftPadding">
            <div class="title-item topSpace">LOGIN</div>
            <div class="text-item break-word" v-if="editingAgentId !== a.id">{{ a.login }}</div>
            <input v-if="editingAgentId === a.id" class="col-sm-12 form-control input-edit" type="text"
                   v-model="edit.login" :disabled="true"/>
          </div>
          <div class="col-sm-6 col--noRightPadding">
            <div class="title-item topSpace">MOT DE PASSE</div>
            <div class="text-item text-item--password">********</div>
            <a v-if="editingAgentId === a.id" class="change-password"
               v-on:click="displayChangePasswordModal()">Modifier</a>
          </div>
          <!-- AJOUT DU PROFIL -->
          <div class="col-sm-12 col--noLeftPadding">
            <div class="title-item topSpace">PROFIL</div>
            <div class="text-item" v-if="editingAgentId !== a.id">
              <div class="text-item" v-if="editingAgentId !== a.id">{{ a.profile }}</div>
            </div>
            <div class="col-sm-12" v-if="editingAgentId === a.id">
              <input type="radio" id="expert" value="Expert" v-model="edit.profile">
              <label for="expert">Expert</label>
              <br>
              <input type="radio" id="novice" value="Novice" v-model="edit.profile">
              <label for="novice">Novice</label>
            </div>
          </div>
        </div>
        <div class="col-sm-2 item-details left-separator right-separator">
          <div>
            <div class="title-item botton-space">RÉFÉRENT SUR LES RONDES</div>
            <ul>
              <li class="text-item" v-for="rr in a.rondesReferent" :key="$index">{{ rr }}</li>
            </ul>
          </div>
        </div>
        <div class="col-sm-2 item-details right-separator">
          <div>
            <div class="title-item botton-space">PLANIFIÉ ACTUELLEMENT SUR</div>
            <ul>
              <li class="text-item" v-for="rp in a.rondesPlanifies" :key="$index">{{ rp }}</li>
            </ul>
          </div>
        </div>
        <div class="col-sm-2 item-details right-separator">
          <div>
            <div class="title-item botton-space">RONDES DÉJÀ RÉALISÉES</div>
            <ul>
              <li class="text-item" v-for="re in a.rondesAlreadyDone" :key="$index">{{ re }}</li>
            </ul>
          </div>
        </div>
        <div class="col-sm-2 item-details">
          <div class="title-item">DERNIÈRE ACTIVITÉ</div>
          <div v-if="a.lastActivity"
               class="text-item last-activity"
               :class="getLastActivityClass(a.lastActivity)"
          >
            <div class="pastille"></div>
            <span>{{ !a.lastActivity ? '' : a.lastActivity | dateFormatterLastActivity }}</span>
          </div>
          <div v-if="!a.lastActivity"
               class="text-item last-activity">
            <span class="no-data">-</span>
          </div>
        </div>
      </div>

      <div slot="bottom-actions"
           v-if="selectedAgent.id === a.id">
        <activate-deactivate-button
          :state="!a.actif"
          @activate="activateAgent(a)"
          @deactivate="showConfirmModal = true">
        </activate-deactivate-button>
        <modify-save-button
          :state="editingAgentId !== a.id"
          @modify="openEditionMode(a)"
          @save="updateAgentInfo()">
        </modify-save-button>
      </div>

    </content-row>

  </section>
</template>

<script>
import _ from 'lodash'
import {mapState} from 'vuex'
import ActivateDeactivateButton from '../../shared/ActivateDeactivateButton'
import config from '../../../config'
import ContentRow from '../../shared/ContentRow'
import ChangePasswordModal from '../../shared/ChangePasswordModal'
import DeactivationModal from '../../shared/DeactivationModal'
import Message from '../../shared/Message'
import ModifySaveButton from '../../shared/ModifySaveButton'
import moment from 'moment'
import PersonCreateView from '../../shared/PersonCreate'
import {dateFormatterLastActivity} from '../../../filters'

export default {
  computed: {
    ...mapState([
      'agents',
    ]),
    sortedAgents: function () {
      return this.$store.getters.sortedListAgents
    },
  },
  data: function () {
    return {
      edit: {
        prenom: '',
        nom: '',
        login: '',
        password: '',
        profile: '',
      },
      selectedAgent: {
        id: null,
      },
      prenomValidationMessage: '',
      nomValidationMessage: '',
      editingAgentId: null,
      showConfirmModal: false,
      showProfilSection: true,
    }
  },
  mounted: function () {
    this.fetchAgents()
  },
  beforeDestroy() {
    console.log("Leaving the page - Perform cleanup here");
    this.resetCreateModal()
  },
  components: {
    ActivateDeactivateButton,
    ChangePasswordModal,
    ContentRow,
    DeactivationModal,
    Message,
    ModifySaveButton,
    PersonCreateView,
  },
  methods: {
    activateAgent: function (agent) {
      this.$store.dispatch('activateAgentV2', agent)
    },
    closeAgentDetails: function () {
      this.selectedAgent.id = null
    },
    /*     closeEditionMode: function () {
          this.selectedAgent.prenom = this.edit.prenom
          this.selectedAgent.nom = this.edit.nom
          this.selectedAgent.profile = this.edit.profile
          console.log('modify plzzzzzzzz  ', this.selectedAgent)
          if(this.validatePrenom() && this.validateNom()){
            console.log("let's go")
            this.$store.dispatch('updateAgentV2', this.selectedAgent)
            this.editingAgentId = null
          }
        }, */
    createAgent: function (newAgent) {
      console.log('new Agent ', newAgent)
      this.$store.dispatch('createAgentV2', newAgent)
    },
    deactivateAgent: function () {
      console.log('desactivéé liya ')
      this.showConfirmModal = false
      this.$store.dispatch('deactivateAgentV2', this.selectedAgent)
    },
    displayAgentCreationBox: function () {
      this.$store.commit('CLEAR_AGENTS_MESSAGE')
      this.$store.commit('DISPLAY_AGENT_CREATE_BOX')
    },
    displayChangePasswordModal: function () {
      this.$store.dispatch('showPasswordChangeModal')
    },
    fetchAgents: async function () {
      await this.$store.dispatch('fetchAgentsList')
    },
    getLastActivityClass: function (dateStr) {
      if (dateStr === null) return

      if (dateStr) {

        const lastActivityDate = new Date(dateStr)
        const currentDate = new Date()

        const timeDiffInMilliseconds = Math.abs(currentDate - lastActivityDate)

        const timeDiffInMinutes = Math.floor(timeDiffInMilliseconds / 60000)

        if (timeDiffInMinutes >= 1440) {
          return 'grey'
        } else if (timeDiffInMinutes <= 15) {
          return 'green'
        } else if (timeDiffInMinutes <= 30) {
          return 'orange'
        } else {
          return 'red'
        }
      }
    },
    openAgentDetails: function (agent) {
      this.selectedAgent = _.cloneDeep(agent)
      this.nomValidationMessage = ''
      this.prenomValidationMessage = ''
    },
    openEditionMode: function (agent) {
      this.editingAgentId = agent.id
      this.edit.prenom = agent.prenom
      this.edit.nom = agent.nom
      this.edit.login = agent.login
      this.edit.profile = agent.profile

    },
    resetCreateModal: function () {
      this.$store.commit('HIDE_AGENT_CREATE_BOX')
      this.$store.commit('CLEAR_AGENTS_MESSAGE')
    },
    updateAgentInfo: function () {
      this.selectedAgent.prenom = this.edit.prenom
      this.selectedAgent.nom = this.edit.nom
      this.selectedAgent.profile = this.edit.profile
      console.log('modify plzzzzzzzz  ', this.selectedAgent)
      if (this.validatePrenom() && this.validateNom()) {
        console.log('let\'s go')
        this.$store.dispatch('updateAgentV2', this.selectedAgent)
        this.editingAgentId = null
      }
    },
    validatePrenom () {
      console.log('this.person.firstname ::: ', this.edit.prenom)
      if (this.edit.prenom.trim() === '') {
        console.log('error first name ')
        this.prenomValidationMessage =
          'Le prénom ne doit pas être vide.'
        return false
      } else {
        this.prenomValidationMessage = ''
        return true
      }
    },
    validateNom () {
      console.log('this.person.firstname ::: ', this.edit.nom)
      if (this.edit.nom.trim() === '') {
        console.log('error first name ')
        this.nomValidationMessage =
          'Le nom ne doit pas être vide.'
        return false
      } else {
        this.nomValidationMessage = ''
        return true
      }
    }
  },
}
</script>

<style lang="scss">
@import "../../../scss/variables";

#agent-list {

  .col--noLeftPadding {
    padding-left: 0;
  }

  .col--noRightPadding {
    padding-right: 0;
  }

  .last-activity {
    &.green {
      .pastille {
        background-color: $status-green;
      }
    }

    &.orange {
      .pastille {
        background-color: $status-orange;
      }
    }

    &.red {
      .pastille {
        background-color: $status-red;
      }
    }

    &.grey {
      .pastille {
        background-color: $suez-grey-dark;
      }
    }

    .pastille {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-left: 5px;
      vertical-align: bottom;
      border-radius: 10px;
    }
  }
}
.error-message {
  color: red;
}
</style>



// WEBPACK FOOTER //
// AgentsList.vue?471ed940